module.exports = __webpack_public_path__ + "img/icon_bank@2x.1833c57d.png";